/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:24px;font-weight:700;letter-spacing:-1px;color:var(--blue-medium);padding:10px 0 0 5px}@media only screen and (max-width:676px){.card[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:18px}}.card[_ngcontent-%COMP%]   .card-body[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-size:14px;font-weight:300;color:var(--blue-medium);-webkit-transition:.3s;transition:all .3s}.card[_ngcontent-%COMP%]   .card-body[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:var(--color-green)}"];
export { styles as styles };
